<script setup>
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from '@/components/ui/breadcrumb'
import {Separator} from "@/components/ui/separator";
import {RouterLink, useRoute, useRouter} from 'vue-router'
import {Skeleton} from '@/components/ui/skeleton'
import {cn} from "@/lib/utils.js";
import {Button} from "@/components/ui/button/index.js";
import {computed} from "vue";

const $route = useRoute()
const $router = useRouter()

const props = defineProps({
  organisation: {
    type: Object,
    required: false,
    default: null
  },

  app: {
    type: Object,
    required: false,
    default: null
  },

  panel: {
    type: Object,
    required: false,
    default: null
  }
});
</script>

<template>
  <div class="container">
    <div class="hidden space-y-6 md:block" v-if="organisation && app && panel">
      <Breadcrumb>
        <BreadcrumbList>
          <BreadcrumbItem>
            <RouterLink to="/">Companies</RouterLink>
          </BreadcrumbItem>
          <BreadcrumbSeparator/>
          <BreadcrumbItem>
            <RouterLink :to="{name: 'OrganisationDashboard', params: {organisationId: organisation.id}}">{{ organisation.name }}</RouterLink>
          </BreadcrumbItem>
          <BreadcrumbSeparator/>
          <BreadcrumbItem>
            <RouterLink :to="{name: 'AppDashboard', params: {organisationId: organisation.id, appId: app.id }}">{{ app.name }}</RouterLink>
          </BreadcrumbItem>
          <BreadcrumbSeparator/>
          <BreadcrumbItem>
            <BreadcrumbPage>{{ panel.name }}</BreadcrumbPage>
          </BreadcrumbItem>
        </BreadcrumbList>
      </Breadcrumb>
    </div>
    <Separator class="my-8"/>

    <div class="flex flex-col space-y-8 lg:flex-row lg:space-x-12 lg:space-y-0">
      <aside class="w-1/5 pt-6">
        <h2 class="text-lg font-semibold mb-2">
          {{ panel?.name || 'Loading...' }}
        </h2>

        <nav class="flex space-x-2 lg:flex-col lg:space-x-0 lg:space-y-1">
          <Button
              @click="$router.push({path: `/${$route.params.organisationId}/app/${$route.params.appId}/panel/${$route.params.panelId}`})"
              variant="ghost"
              :class="cn(
        'w-full text-left justify-start',
        $route.path === `/${$route.params.organisationId}/app/${$route.params.appId}/panel/${$route.params.panelId}` && 'bg-muted hover:bg-muted',
      )">
            Content
          </Button>

          <Button
              @click="$router.push({path: `/${$route.params.organisationId}/app/${$route.params.appId}/panel/${$route.params.panelId}/settings`})"
              variant="ghost"
              :class="cn(
        'w-full text-left justify-start',
        $route.path === `/${$route.params.organisationId}/app/${$route.params.appId}/panel/${$route.params.panelId}/settings` && 'bg-muted hover:bg-muted',
      )">
            Settings
          </Button>

          <Button
              @click="$router.push({path: `/${$route.params.organisationId}/app/${$route.params.appId}/panel/${$route.params.panelId}/history`})"
              variant="ghost"
              :class="cn(
        'w-full text-left justify-start',
        $route.path === `/${$route.params.organisationId}/app/${$route.params.appId}/panel/${$route.params.panelId}/history` && 'bg-muted hover:bg-muted',
      )">
            History
          </Button>
        </nav>
      </aside>
      <div class="flex-1 lg:max-w-2xl">
        <div class="space-y-6">
          <slot/>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
</style> 